<h2 mat-dialog-title>Dados do atendimento - {{ data.param.id }}</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="schedule">
    <b> {{ schedule.type }}:</b> {{ schedule.procedure ? schedule.procedure.name : '' }} <span *ngIf="organization">{{ organization.name }}</span>
    <br />
    <b> Data e Hora:</b> {{ layout.dateTimeFormat(schedule.dateStart) }}
  </div>
  <mat-tab-group>
    <mat-tab label="Dados do Paciente">
      <br /><b>Nome:</b> {{ schedule.patient.name }} <br />
      <b>Data de nascimento:</b> {{ schedule.patient.birthDate || 'Undefined' | mask: '00/00/0000}} <br />
      <b>CPF:</b> {{ schedule.patient.cpf || 'Undefined' | mask: '000.000.000-00}} <br />
      <b>Gênero:</b> {{ schedule.patient.gender }} <br />
      <b>Telefone:</b> {{ schedule.patient.mobile || 'Undefined' | mask : '(00) 00000-0000' }} <br />
      <b>Endereço:</b>
      <page-data-person [person]="schedule.patient"></page-data-person>
      <page-map-view [address]="address"></page-map-view>
    </mat-tab>
    <mat-tab label="Observação">
      <div>
        <p>Informe aqui a observação do paciente:</p>
        <textarea matInput rows="5" [(ngModel)]="encounter.diagnosis" placeholder="Digite a observação aqui"></textarea>
        <button mat-flat-button color="primary" (click)="saveDiagnosis()">Salvar Observação</button>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="warn" cdkFocusInitial (click)="cancelSchedule()">Cancelar atendimento</button>
</mat-dialog-actions>
